module.exports = "/lucky-balls/img/drum/drum_loop_010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_010.png
// module id = 1025
// module chunks = 0